var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ai__Type=AI",
    className: "ai__Type=AI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai__Vector",
    fill: "currentColor",
    d: "M6.92 3.44a.606.606 0 0 1 1.018.119l1.183 2.48 2.388 1.195a.605.605 0 0 1 0 1.082L9.103 9.528l-1.448 2.553a.605.605 0 0 1-1.072-.037l-1.21-2.521L3.015 8.37A.605.605 0 0 1 3 7.29l2.39-1.257 1.48-2.52.05-.073Zm-.675 3.247a.606.606 0 0 1-.24.229l-1.701.895 1.682.822c.123.06.222.16.28.282l.895 1.869 1.082-1.905a.605.605 0 0 1 .178-.196l.076-.046 1.708-.86-1.704-.854a.606.606 0 0 1-.276-.28L7.35 4.805 6.245 6.687ZM15.12 9.62a.606.606 0 0 1 1.019.12l1.605 3.364 3.245 1.625a.606.606 0 0 1 .001 1.082l-3.264 1.643-1.96 3.453a.605.605 0 0 1-1.072-.037l-1.64-3.42-3.206-1.568a.605.605 0 0 1-.016-1.08l3.238-1.704 2-3.404.05-.074Zm-1.195 4.133a.607.607 0 0 1-.24.23l-2.548 1.34 2.53 1.236c.123.06.221.16.28.283l1.327 2.768 1.592-2.805.05-.074a.607.607 0 0 1 .127-.122l.077-.046 2.566-1.291-2.563-1.283a.606.606 0 0 1-.275-.28l-1.298-2.722-1.625 2.766Z",
    className: "ai__Vector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.8eb0ab28532b47858a0f24671dd59173.svg";
export { ForwardRef as ReactComponent };